import { render } from "./MSMessagePanel.vue?vue&type=template&id=2b3bfc0b&scoped=true&ts=true"
import script from "./MSMessagePanel.vue?vue&type=script&lang=ts"
export * from "./MSMessagePanel.vue?vue&type=script&lang=ts"

import "./MSMessagePanel.vue?vue&type=style&index=0&id=2b3bfc0b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3bfc0b"]])

export default __exports__